import React, { Component } from 'react';
import styled from 'styled-components';
import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';

const H3 = styled.h3`
  color: #748495;
  font-size: 42px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 2em;
  margin-top: 80px;
`;

class ConnectWithUs extends Component {
  render() {
    return (
      <div className="ConnectWithUs">
        <H3>
          {i18n.t('connectWithUs')}
        </H3>
        <div className="text-center">
          {i18n.t('plzEmailTo')}<br />
          {i18n.t('iHealthCareEmail')}<br />
          <div style={{ marginTop: 40 }}>
            <a
              href="mailto:connect@ihealthcareclouds.com"
              target="_top"
              className="btn boca-btn"
            >
              {i18n.t('send_mail')}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default connectActionsAndReducers(ConnectWithUs);



// WEBPACK FOOTER //
// ./src/components/static/ConnectWithUs.js